import { useQueryParams } from '@/hooks';
import QueryParamsContext from './QueryParamsContext';

export function QueryParamsProvider({ children, defaultParams = {} }) {
  const { queryParams, queryParamsString, setQueryParams } =
    useQueryParams(defaultParams);

  return (
    <QueryParamsContext.Provider
      value={{ queryParams, queryParamsString, setQueryParams }}
    >
      {children}
    </QueryParamsContext.Provider>
  );
}
